import {TEXTAREA} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXTAREA,
  attribute: 'custom_repo_reason',
  label: {
    default: 'Reason - Description',
    short: 'Reason - Description',
  },
});
